import React, { useContext, useMemo } from "react";
import { Grid } from "@mui/material";
import Select from "react-select";
import { personnelListContext } from "../../PersonnelListPage";

export default function ProjectIdField({ value, onChange }) {
  const { recruitment = [] } = useContext(personnelListContext);

  const reversedRecruitment = useMemo(
    () => [...recruitment].reverse(),
    [recruitment]
  );

  const handleChange = (selectedOption) => {
    onChange({ project_id: selectedOption ? selectedOption.id : "" });
  };

  const selectedValue =
    recruitment.find((option) => option.id === value) || null;

  return (
    <>
      <Grid
        item
        xs={4}
        sm={1.5}
        sx={{
          fontWeight: "bold",
          paddingLeft: { sm: "20px" },
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        募集
      </Grid>
      <Grid
        item
        xs={8}
        sm={10.5}
        sx={{
          fontWeight: "bold",
          paddingLeft: { sm: "20px" },
          paddingBottom: "20px",
        }}
      >
        <div style={{ wordWrap: "break-word" }}>
          <Select
            options={reversedRecruitment}
            getOptionLabel={(option) => option.mail_subject || ""}
            getOptionValue={(option) => option.id}
            placeholder="募集情報を選択してください"
            onChange={handleChange}
            isClearable
            styles={{
              option: (provided) => ({
                ...provided,
                paddingLeft: 10,
              }),
            }}
            value={selectedValue}
          />
        </div>
      </Grid>
    </>
  );
}